import React, { useRef } from 'react';
import { createPortal } from 'react-dom';

import { Post, type IPost } from '../../components/Post';
import { DealsLeadFormBlock, type IDealsLeadFormBlockProps } from '../../components/DealsLeadForm';
import { DealsExperiment } from '../../constants/dealsExperiment';
import { usePlaceBeforeTrailingCaption } from './utils';

/**
 * Вынесен в отдельный компонент, чтобы DealsExperiment.use() вызывался только для статей
 * из эксперимента — вызвать его условно прямо в PostContainer нельзя из-за правил хуков.
 * Форма показывается только в тестовой группе B — внутри статьи:
 * перед хвостовыми `.caption` или в конце контента, если caption нет.
 */
export const DealsExperimentArticle = ({
  dealsLeadForm,
  postProps,
}: {
  dealsLeadForm: IDealsLeadFormBlockProps;
  postProps: IPost;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const group = DealsExperiment.use();
  const showForm = group === 'B';
  const formMountNode = usePlaceBeforeTrailingCaption(contentRef, showForm, postProps.content);

  const form = showForm ? <DealsLeadFormBlock {...dealsLeadForm} /> : null;

  return (
    <>
      <Post {...postProps} contentRef={contentRef} />
      {form && formMountNode && createPortal(form, formMountNode)}
    </>
  );
};
